import { render } from "./followRecordAdd.vue?vue&type=template&id=4f77f7f8&scoped=true"
import script from "./followRecordAdd.vue?vue&type=script&lang=js"
export * from "./followRecordAdd.vue?vue&type=script&lang=js"

import "./followRecordAdd.vue?vue&type=style&index=0&id=4f77f7f8&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f77f7f8"]])

export default __exports__